(() => {
  const money = (cents) => {
    if (typeof formatMoney === 'function') return formatMoney(cents);
    return `$${Math.round(cents / 100)}`;
  };

  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);

  const boot = () => {
    document.querySelectorAll('[data-product-root].fdo-product').forEach((root) => {
      if (root.dataset.fdoReady === 'true') return;
      if (!root.querySelector('[data-fdo-step], [data-fdo-summary]')) return;
      root.dataset.fdoReady = 'true';
      initBuilder(root);
    });
  };

  function initBuilder(root) {
    const tags = root.querySelector('[data-fdo-build-tags]');
    const summary = root.querySelector('[data-fdo-summary]');
    const notebooks = root.querySelector('[data-fdo-step="notebooks"]');
    const engravingStep = root.querySelector('[data-fdo-step="engraving"]');
    const included = Number(notebooks?.dataset.included || 0);
    const maximum = Number(notebooks?.dataset.max || 6);
    const state = {
      base: Number(summary?.dataset.basePrice || 0),
      cord: null,
      engraving: '',
      notebooks: {},
      charms: { decided: false, items: [] },
    };

    const setProperty = (key, value) => {
      const input = root.querySelector(`[data-fdo-property="${key}"]`);
      if (!input) return;
      const text = value == null ? '' : String(value);
      input.value = text;
      input.disabled = text === '';
    };

    const render = () => {
      let allowance = included;
      let notebookCost = 0;
      const notebookLines = [];
      const notebookLabels = [];
      const includedSelections = [];
      const extraSelections = [];
      const formatSelections = (parts) =>
        parts.map((part) => (part.qty > 1 ? `${part.name} ×${part.qty}` : part.name)).join(', ');
      const notebookQty = Object.values(state.notebooks).reduce((sum, qty) => sum + qty, 0);

      root.querySelectorAll('[data-fdo-notebook]').forEach((card) => {
        const qty = state.notebooks[card.dataset.id] || 0;
        card.classList.toggle('is-selected', qty > 0);
        const value = card.querySelector('[data-fdo-qty-value]');
        if (value) value.textContent = String(qty);
        const minus = card.querySelector('[data-fdo-qty="-1"]');
        const plus = card.querySelector('[data-fdo-qty="1"]');
        if (minus) minus.disabled = qty === 0;
        if (plus) plus.disabled = notebookQty >= maximum || card.dataset.available === 'false';
        const price = Number(card.dataset.price) || 0;
        const free = Math.min(qty, allowance);
        allowance -= free;
        const paid = qty - free;
        card.classList.toggle('is-included', free > 0);
        card.classList.toggle('is-extra', paid > 0);
        const status = card.querySelector('[data-fdo-notebook-status]');
        if (status) {
          if (!qty) status.textContent = money(price);
          else if (free > 0 && paid > 0) status.textContent = `${free} included · ${paid} extra`;
          else if (free > 0) status.textContent = free > 1 ? `${free} included` : 'Included';
          else status.textContent = paid > 1 ? `${paid} extra` : 'Extra';
        }
        if (!qty) return;
        notebookCost += paid * price;
        notebookLabels.push(qty > 1 ? `${card.dataset.name} ×${qty}` : card.dataset.name);
        if (free > 0) includedSelections.push({ name: card.dataset.name, qty: free });
        if (paid > 0) extraSelections.push({ name: card.dataset.name, qty: paid });
        if (qty > 0 && card.dataset.variantId) {
          notebookLines.push({
            role: 'notebook',
            id: Number(card.dataset.variantId),
            quantity: qty,
          });
        }
      });

      const engravingCost = state.engraving.trim() ? Number(engravingStep?.dataset.price || 0) : 0;
      const charmMax = Number(root.querySelector('[data-fdo-charm-max]')?.dataset.fdoCharmMax || 4);
      const charmItems = state.charms.items;
      const charmCost = charmItems.reduce((sum, item) => sum + (item.price || 0), 0);
      const total = state.base + engravingCost + notebookCost + charmCost;

      const cordLabel = root.querySelector('[data-fdo-cord-label]');
      if (cordLabel) cordLabel.textContent = state.cord?.name || 'Choose one';

      const engravingLabel = root.querySelector('[data-fdo-engraving-label]');
      if (engravingLabel) {
        engravingLabel.textContent = state.engraving.trim()
          ? `+${money(engravingCost)}`
          : 'optional';
      }

      const notebookLabel = root.querySelector('[data-fdo-notebook-label]');
      if (notebookLabel) {
        notebookLabel.textContent =
          included > 0 && notebookQty < included
            ? `${notebookQty}/${included} selected`
            : included > 0 && notebookQty === included
              ? `${included} included`
              : `${notebookQty} selected`;
      }

      const charmPrompt = state.charms.decided ? 'No charm' : 'Select a charm';
      const charmNames = charmItems.map((item) => item.name).join(', ');
      const charmLabel = root.querySelector('[data-fdo-charm-label]');
      if (charmLabel) {
        charmLabel.textContent = charmItems.length
          ? `${charmItems.length} of ${charmMax}`
          : state.charms.decided
            ? 'No charm'
            : `Up to ${charmMax}`;
      }
      const charmChoice = root.querySelector('[data-fdo-charm-choice]');
      if (charmChoice) {
        charmChoice.textContent = charmPrompt;
        charmChoice.hidden = charmItems.length > 0;
      }
      const charmPicks = root.querySelector('[data-fdo-charm-picks]');
      if (charmPicks) {
        charmPicks.replaceChildren();
        charmItems.forEach((item) => {
          const line = document.createElement('span');
          line.className = 'fdo-charm-open__pick';
          const name = document.createElement('span');
          name.textContent = item.name;
          const price = document.createElement('span');
          price.textContent = item.price > 0 ? `+${money(item.price)}` : 'Free';
          line.append(name, price);
          charmPicks.appendChild(line);
        });
        charmPicks.hidden = charmItems.length === 0;
      }
      const charmChoicePrice = root.querySelector('[data-fdo-charm-choice-price]');
      if (charmChoicePrice) charmChoicePrice.textContent = '';
      const charmAction = root.querySelector('[data-fdo-charm-action]');
      if (charmAction) charmAction.textContent = state.charms.decided ? 'Change' : 'Shop';
      const charmChoiceMedia = root.querySelector('[data-fdo-charm-choice-media]');
      if (charmChoiceMedia) {
        charmChoiceMedia.replaceChildren();
        charmItems.forEach((item) => {
          if (!item.image) return;
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.width = 48;
          image.height = 48;
          charmChoiceMedia.appendChild(image);
        });
        charmChoiceMedia.hidden = charmChoiceMedia.childElementCount === 0;
      }

      const showRow = (name, visible) => {
        const row = root.querySelector(`[data-fdo-row="${name}"]`);
        if (row) row.hidden = !visible;
      };

      const baseEl = root.querySelector('[data-fdo-base]');
      if (baseEl) baseEl.textContent = money(state.base);
      const totalEl = root.querySelector('[data-fdo-total]');
      if (totalEl) totalEl.textContent = money(total);

      showRow('cord', true);
      const cordName = root.querySelector('[data-fdo-cord-name]');
      const cordPrice = root.querySelector('[data-fdo-cord-price]');
      if (cordName) cordName.textContent = state.cord ? `${state.cord.name} cord` : 'Cord';
      if (cordPrice) cordPrice.textContent = 'Included';

      showRow('engraving', engravingCost > 0);
      const engravingPrice = root.querySelector('[data-fdo-engraving-price]');
      if (engravingPrice) engravingPrice.textContent = `+${money(engravingCost)}`;

      showRow('notebooks-included', included > 0);
      const notebookIncludedLabel = root.querySelector('[data-fdo-notebook-included-label]');
      if (notebookIncludedLabel) {
        notebookIncludedLabel.textContent = includedSelections.length
          ? formatSelections(includedSelections)
          : included === 1
            ? '1 notebook included'
            : `${included} notebooks included`;
      }

      showRow('notebooks', true);
      const notebookExtraLabel = root.querySelector('[data-fdo-notebook-extra-label]');
      const notebookExtraPrice = root.querySelector('[data-fdo-notebook-extra-price]');
      if (notebookExtraLabel) {
        notebookExtraLabel.textContent = extraSelections.length
          ? formatSelections(extraSelections)
          : 'No extra notebook';
      }
      if (notebookExtraPrice) {
        notebookExtraPrice.textContent = extraSelections.length ? `+${money(notebookCost)}` : '';
      }

      showRow('charm', true);
      const charmName = root.querySelector('[data-fdo-charm-name]');
      const charmPrice = root.querySelector('[data-fdo-charm-price]');
      if (charmName) {
        charmName.replaceChildren();
        if (charmItems.length) {
          charmItems.forEach((item) => {
            const line = document.createElement('span');
            line.textContent = item.name;
            charmName.appendChild(line);
          });
        } else {
          charmName.textContent = state.charms.decided ? 'No Charm' : 'Select a charm';
        }
      }
      if (charmPrice) charmPrice.textContent = charmCost > 0 ? `+${money(charmCost)}` : '';

      setProperty('cord', state.cord?.name || '');
      setProperty('notebooks', '');
      setProperty('charm', '');

      const items = [];
      if (state.engraving.trim() && engravingStep?.dataset.variantId) {
        items.push({
          role: 'engraving',
          id: Number(engravingStep.dataset.variantId),
          quantity: 1,
        });
      }
      items.push(...notebookLines);
      charmItems.forEach((item) => {
        if (!item.variantId) return;
        items.push({ role: 'charm', id: Number(item.variantId), quantity: 1 });
      });

      const ready = Boolean(state.cord) && notebookQty >= 1;
      const plan = {
        total,
        ready,
        cord: state.cord?.name || null,
        engraving: state.engraving.trim() || null,
        notebooks: state.notebooks,
        notebookLabels,
        charmLabels: charmItems.map((item) => item.name),
        charm: charmItems.length ? charmItems.map((item) => item.name) : null,
        items,
      };
      setProperty('bundle', JSON.stringify(plan));
      root.fdoBundlePlan = plan;
      const productForm = root.querySelector('form[data-product-form]');
      if (productForm) productForm.fdoBundlePlan = plan;
      syncCartGate(root, ready, state.cord, notebookQty);
      syncPreview();

      if (!tags) return;
      const chips = [];
      if (state.cord) chips.push(`${state.cord.name} cord`);
      if (notebookLabels.length) chips.push(notebookLabels.join(', '));
      charmItems.forEach((item) => chips.push(item.name));
      tags.innerHTML = chips
        .map((chip) => `<span class="fdo-build-tag">${escapeHtml(chip)}</span>`)
        .concat(
          state.engraving.trim()
            ? [`<span class="fdo-build-tag fdo-build-tag--script">“${escapeHtml(state.engraving.trim().slice(0, 14))}”</span>`]
            : []
        )
        .join('');
    };

    root.querySelectorAll('[data-fdo-cord]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        state.cord = {
          name: button.dataset.name,
          variantId: button.dataset.variantId,
          price: Number(button.dataset.price) || 0,
          color: button.dataset.color || '',
        };
        root.querySelectorAll('[data-fdo-cord]').forEach((el) => {
          const selected = el === button;
          el.classList.toggle('is-selected', selected);
          el.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        render();
      });
    });

    const engraving = root.querySelector('[data-fdo-engraving]');
    engraving?.addEventListener('input', () => {
      const max = Number(engraving.dataset.max || 22);
      state.engraving = engraving.value.slice(0, max);
      const count = root.querySelector('[data-fdo-engraving-count]');
      if (count) count.textContent = `${state.engraving.length}/${max}`;
      render();
    });

    root.querySelectorAll('[data-fdo-notebook]').forEach((card) => {
      state.notebooks[card.dataset.id] = 0;
      card.querySelectorAll('[data-fdo-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          const id = card.dataset.id;
          const current = state.notebooks[id] || 0;
          const next = Math.max(0, current + Number(button.dataset.fdoQty));
          const total = Object.values(state.notebooks).reduce((sum, qty) => sum + qty, 0) - current + next;
          if (total > maximum) return;
          state.notebooks[id] = next;
          render();
        });
      });
    });

    bindCharmDrawer(root, state, render);

    document.addEventListener('theme:variant:change', (event) => {
      if (event.detail?.productRootEl !== root) return;
      const price = event.detail.variant?.price;
      if (typeof price === 'number') {
        state.base = price;
        render();
      }
    });

    bindCartAdd(root);
    watchCordFit(root.querySelector('[data-fdo-preview]'));
    render();

    function syncPreview() {
      const preview = root.querySelector('[data-fdo-preview]');
      if (!preview) return;

      const cordImg = preview.querySelector('[data-fdo-preview-cord]');
      const charmStack = preview.querySelector('[data-fdo-preview-charms]');
      const engravingEl = preview.querySelector('[data-fdo-preview-engraving]');
      const cordColor = state.cord?.color || '';
      const charmKey = state.charms.items
        .map((item) => `${item.variantId}:${item.size || ''}`)
        .join('|');

      if (cordImg) {
        if (cordColor) {
          cordImg.style.setProperty('--fdo-cord-color', cordColor);
          cordImg.hidden = false;
        } else {
          cordImg.hidden = true;
          cordImg.style.removeProperty('--fdo-cord-color');
        }
      }

      if (charmStack && charmStack.dataset.charms !== charmKey) {
        charmStack.replaceChildren();
        const metrics = getComputedStyle(preview);
        const journalWidth = Number(metrics.getPropertyValue('--fdo-journal-width')) || 148;
        const journalHeight = Number(metrics.getPropertyValue('--fdo-journal-height')) || 210;
        const coverHeight = Number(metrics.getPropertyValue('--fdo-cover-height')) || 0.943;
        state.charms.items.forEach((item) => {
          if (!item.image) return;
          const image = document.createElement('img');
          image.className = 'fdo-preview__charm';
          image.alt = item.name || '';
          image.crossOrigin = 'anonymous';
          image.addEventListener('load', () => {
            let tries = 0;
            const place = () => {
              const previewWidth = preview.clientWidth;
              if (!previewWidth && tries < 30) {
                tries += 1;
                requestAnimationFrame(place);
                return;
              }
              if (!previewWidth) return;
              const cutout = charmCutoutBox(image);
              const length = ((item.size || 28) / journalHeight) * coverHeight;
              const span = (length / cutout.length) * (journalHeight / journalWidth);
              const displayWidth = span * previewWidth;
              const displayHeight = displayWidth * (image.naturalHeight / image.naturalWidth || 1);
              const px = `${displayWidth}px`;
              image.style.width = px;
              image.style.minWidth = px;
              image.style.marginTop = `${-cutout.top * displayHeight}px`;
              image.dataset.cutoutLeft = String(cutout.left);
              image.dataset.cutoutRight = String(cutout.right);
              image.dataset.cutoutTop = String(cutout.top);
              image.dataset.ready = 'true';
              requestAnimationFrame(() => packCharmRow(charmStack, preview));
            };
            place();
          });
          image.src = item.image;
          charmStack.appendChild(image);
        });
        charmStack.dataset.charms = charmKey;
        charmStack.hidden = charmStack.childElementCount === 0;
      }

      if (engravingEl) {
        const text = state.engraving.trim();
        engravingEl.textContent = text;
        engravingEl.hidden = text === '';
        engravingEl.classList.toggle('is-long', text.length > 5);
      }
    }
  }

  function syncCartGate(root, ready, cord, notebookQty) {
    root.querySelectorAll('.add-to-cart-btn').forEach((button) => {
      if (button.dataset.fdoAvailable == null) {
        button.dataset.fdoAvailable = button.disabled ? 'false' : 'true';
      }
      if (button.dataset.fdoAvailable === 'false') return;
      button.disabled = !ready;
      button.setAttribute('aria-disabled', ready ? 'false' : 'true');
    });
    root.querySelectorAll('.dynamic-payment-buttons').forEach((buttons) => {
      buttons.classList.toggle('is-locked', !ready);
      if (ready) buttons.removeAttribute('inert');
      else buttons.setAttribute('inert', '');
    });
    const hint = root.querySelector('[data-fdo-cart-hint]');
    if (!hint) return;
    if (ready) {
      hint.hidden = true;
      return;
    }
    hint.hidden = false;
    if (!cord && notebookQty < 1) {
      hint.textContent = 'Select a cord color and at least 1 notebook to add to cart';
    } else if (!cord) {
      hint.textContent = 'Select a cord color to add to cart';
    } else {
      hint.textContent = 'Select at least 1 notebook to add to cart';
    }
  }

  function fitCord(preview) {
    const width = preview.clientWidth;
    const height = preview.clientHeight;
    if (!width || !height) return;
    // 84% was tuned on a typical portrait. Size from the shorter side so a
    // wider photo does not stretch the cord, and a smaller one does not shrink it.
    const cordWidth = Math.round(Math.min(width, height) * 0.84);
    preview.style.setProperty('--fdo-cord-scale', `${cordWidth}px`);
  }

  function watchCordFit(preview) {
    if (!preview) return;
    const fit = () => fitCord(preview);
    fit();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', fit);
      return;
    }
    const observer = new ResizeObserver(fit);
    observer.observe(preview);
  }

  function packCharmRow(stack, preview) {
    const images = [...stack.querySelectorAll('.fdo-preview__charm')];
    if (!images.length || images.some((image) => image.dataset.ready !== 'true')) return;
    const width = preview.clientWidth || 1;
    const gap = width * (2 / 148) * 0.924;
    images.forEach((image, index) => {
      const left = Number(image.dataset.cutoutLeft) || 0;
      const right = Number(image.dataset.cutoutRight) || 1;
      const box = image.offsetWidth;
      const leftEmpty = left * box;
      const rightEmpty = (1 - right) * box;
      const previous = images[index - 1];
      const previousEmpty = previous
        ? (1 - (Number(previous.dataset.cutoutRight) || 1)) * previous.offsetWidth
        : 0;
      image.style.marginLeft = `${index === 0 ? -leftEmpty : -(previousEmpty + leftEmpty - gap)}px`;
      image.style.marginRight = index === images.length - 1 ? `${-rightEmpty}px` : '0px';
    });
  }

  function charmCutoutBox(image) {
    const empty = { length: 1, left: 0, right: 1, top: 0 };
    const canvas = document.createElement('canvas');
    const longest = Math.max(image.naturalWidth, image.naturalHeight);
    const sample = Math.max(1, Math.round(Math.min(longest, 180)));
    const width = Math.max(1, Math.round((image.naturalWidth / longest) * sample));
    const height = Math.max(1, Math.round((image.naturalHeight / longest) * sample));
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) return empty;
    try {
      context.drawImage(image, 0, 0, width, height);
      const pixels = context.getImageData(0, 0, width, height).data;
      let minX = width;
      let minY = height;
      let maxX = 0;
      let maxY = 0;
      for (let y = 0; y < height; y += 1) {
        for (let x = 0; x < width; x += 1) {
          if (pixels[(y * width + x) * 4 + 3] < 16) continue;
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
      if (maxX < minX || maxY < minY) return empty;
      return {
        length: Math.max((maxX - minX + 1) / width, (maxY - minY + 1) / height),
        left: minX / width,
        right: (maxX + 1) / width,
        top: minY / height,
      };
    } catch {
      return empty;
    }
  }

  function charmMillimeters(details, name) {
    const source = String(details || '')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;|&#160;/g, ' ')
      .replace(/\s+/g, ' ');
    const scoped = source.match(/size(?:\s+of\s+the\s+\w+|\s+of\s+\w+)?\s*:?\s*([^•]{0,48})/i);
    const region = scoped ? scoped[1] : source;
    const pair =
      region.match(/(\d+(?:\.\d+)?)\s*(?:mm)?\s*[x*×~]\s*(\d+(?:\.\d+)?)\s*mm/i) ||
      region.match(/(\d+(?:\.\d+)?)\s*mm\s*[x*×~]\s*(\d+(?:\.\d+)?)/i);
    if (pair) {
      const width = Number(pair[1]);
      const height = Number(pair[2]);
      if (width > 0 && height > 0 && width < 120 && height < 120) return Math.max(width, height);
    }
    const inches = region.match(/(\d+(?:\.\d+)?)\s*(?:inches|inch)/i) || region.match(/(\d+(?:\.\d+)?)i\b/i);
    if (inches) {
      const mm = Number(inches[1]) * 25.4;
      if (mm > 4 && mm < 120) return mm;
    }
    const single = region.match(/(\d+(?:\.\d+)?)\s*mm/i);
    if (single) {
      const mm = Number(single[1]);
      if (mm > 4 && mm < 120) return mm;
    }
    if (/\bmini\b|\bsmall\b/i.test(name || '')) return 16;
    if (/\blarge\b/i.test(name || '')) return 38;
    return 28;
  }

  function charmFromRow(row) {
    return {
      name: row.dataset.name,
      variantId: row.dataset.variantId || '',
      price: Number(row.dataset.price) || 0,
      image: row.dataset.image || '',
      size: Number(row.dataset.size) > 0
        ? Number(row.dataset.size)
        : charmMillimeters(row.dataset.details, row.dataset.name),
    };
  }

  function syncCharmDrawer(drawer, pending) {
    const max = Number(drawer.dataset.fdoCharmMax || 4);
    const selectedIds = new Set(pending.map((item) => String(item.variantId)));
    const atMax = pending.length >= max;
    drawer.querySelectorAll('[data-fdo-charm]').forEach((row) => {
      const selected = selectedIds.has(String(row.dataset.variantId));
      row.classList.toggle('is-selected', selected);
      const button = row.querySelector('[data-fdo-charm-select]');
      if (!button || row.dataset.available === 'false') return;
      button.textContent = selected ? 'Selected' : 'Select';
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.disabled = !selected && atMax;
    });
    const continueButton = drawer.querySelector('[data-fdo-charm-continue]');
    if (continueButton) continueButton.disabled = pending.length === 0;
    const count = drawer.querySelector('[data-fdo-charm-count]');
    if (count) count.textContent = `${pending.length} of ${max}`;
  }

  function createCharmOption({ name, variantId, price, image, available, details }) {
    const row = document.createElement('article');
    row.className = 'fdo-charm-option';
    row.dataset.fdoCharm = '';
    row.dataset.name = name;
    row.dataset.variantId = String(variantId);
    row.dataset.price = String(price);
    row.dataset.image = image || '';
    row.dataset.details = details || '';
    row.dataset.available = available ? 'true' : 'false';
    const media = document.createElement('div');
    media.className = 'fdo-charm-option__media';
    if (image) {
      const img = document.createElement('img');
      img.src = image;
      img.alt = '';
      media.appendChild(img);
    }
    const copy = document.createElement('div');
    copy.className = 'fdo-charm-option__copy';
    const title = document.createElement('strong');
    title.textContent = name;
    const priceEl = document.createElement('span');
    priceEl.textContent = price > 0 ? `+${money(price)}` : 'Free';
    copy.append(title, priceEl);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'fdo-charm-option__select';
    button.dataset.fdoCharmSelect = '';
    button.setAttribute('aria-pressed', 'false');
    button.textContent = available ? 'Select' : 'Sold out';
    button.disabled = !available;
    row.append(media, copy, button);
    return row;
  }

  async function loadRemainingCharms(drawer) {
    const handle = drawer.dataset.collectionHandle;
    const total = Number(drawer.dataset.collectionCount || 0);
    const list = drawer.querySelector('[data-fdo-charm-list]');
    if (!handle || !list || !total) return;
    const seen = new Set(
      [...list.querySelectorAll('[data-fdo-charm]')].map((row) => row.dataset.variantId)
    );
    if (seen.size >= total) return;

    let page = 1;
    let previousCount = Infinity;
    while (seen.size < total && page <= 20) {
      let products = [];
      try {
        const response = await fetch(
          `/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`
        );
        if (!response.ok) break;
        const data = await response.json();
        products = data.products || [];
      } catch {
        break;
      }
      if (!products.length) break;
      products.forEach((product) => {
        const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
        if (!variant || seen.has(String(variant.id))) return;
        seen.add(String(variant.id));
        const image = product.images?.[0]?.src || '';
        const sizedImage = image
          ? `${image}${image.includes('?') ? '&' : '?'}width=640`
          : '';
        list.appendChild(
          createCharmOption({
            name: product.title,
            variantId: variant.id,
            price: Math.round(Number(variant.price) * 100) || 0,
            image: sizedImage,
            available: Boolean(variant.available),
            details: product.body_html || '',
          })
        );
      });
      if (seen.size >= total || (page > 1 && products.length < previousCount)) break;
      previousCount = products.length;
      page += 1;
    }
  }

  function bindCharmDrawer(root, state, render) {
    const drawer = root.querySelector('[data-fdo-charm-drawer]');
    const opener = root.querySelector('[data-fdo-charm-open]');
    if (!drawer || !opener) return;

    document
      .querySelectorAll(`[data-fdo-charm-drawer][data-owner="${root.dataset.productRoot}"]`)
      .forEach((el) => {
        if (el !== drawer) el.remove();
      });
    drawer.dataset.owner = root.dataset.productRoot;
    document.body.appendChild(drawer);

    let pending = state.charms.items.map((item) => ({ ...item }));
    const charmMax = Number(drawer.dataset.fdoCharmMax || 4);
    let returnFocus = opener;
    const panel = drawer.querySelector('.fdo-charm-drawer__panel');

    const sync = (next = pending) => syncCharmDrawer(drawer, next);

    const closeDrawer = () => {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('fdo-charm-drawer-open');
      returnFocus?.focus();
    };

    const openDrawer = () => {
      pending = state.charms.items.map((item) => ({ ...item }));
      sync(pending);
      returnFocus = opener;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('fdo-charm-drawer-open');
      panel?.focus();
    };

    opener.addEventListener('click', openDrawer);

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-fdo-charm-close]')) {
        closeDrawer();
        return;
      }
      if (event.target.closest('[data-fdo-charm-none]')) {
        state.charms = { decided: true, items: [] };
        pending = [];
        render();
        closeDrawer();
        return;
      }
      if (event.target.closest('[data-fdo-charm-continue]')) {
        if (!pending.length) return;
        state.charms = { decided: true, items: pending.map((item) => ({ ...item })) };
        render();
        closeDrawer();
        return;
      }
      const select = event.target.closest('[data-fdo-charm-select]');
      const row = select?.closest('[data-fdo-charm]');
      if (!select || !row || row.dataset.available === 'false') return;
      const charm = charmFromRow(row);
      const index = pending.findIndex((item) => String(item.variantId) === String(charm.variantId));
      if (index >= 0) pending.splice(index, 1);
      else if (pending.length < charmMax) pending.push(charm);
      sync(pending);
    });

    drawer.addEventListener('keydown', (event) => {
      if (drawer.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll('button:not(:disabled), [href], input, select, textarea, [tabindex="0"]')].filter(
        (el) => !el.closest('[hidden]')
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    loadRemainingCharms(drawer).then(() => {
      if (!drawer.hidden) sync();
    });
  }

  function propertiesFromForm(formData) {
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (!match) continue;
      const text = String(value);
      if (text === '') continue;
      properties[match[1]] = text;
    }
    return properties;
  }

  function bindCartAdd(root) {
    const form = root.querySelector('form[data-product-form]');
    if (!form || form.dataset.fdoCartBound === 'true') return;
    form.dataset.fdoCartBound = 'true';
    form.addEventListener(
      'submit',
      (event) => {
        if (!root.fdoBundlePlan?.ready) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const extras = root.fdoBundlePlan?.items || [];
        if (!extras.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        addBundle(form, extras);
      },
      true
    );
  }

  async function addBundle(form, extras) {
    form.dispatchEvent(new CustomEvent('shapes:productform:loading', { bubbles: true }));
    if (typeof liveRegion === 'function' && window.theme?.strings?.loading) {
      liveRegion(window.theme.strings.loading);
    }

    const formData = new FormData(form);
    const formId = form.getAttribute('id');
    const quantity = Math.max(1, Number(formData.get('quantity') || 1));
    const bundleId = `fdo-${Date.now().toString(36)}`;
    const properties = propertiesFromForm(formData);
    delete properties.Notebooks;
    delete properties.Charm;
    const plan = form.fdoBundlePlan || form.closest('[data-product-root]')?.fdoBundlePlan;
    (plan?.notebookLabels || []).forEach((label, index) => {
      properties[`Notebook ${index + 1}`] = label;
    });
    (plan?.charmLabels || []).forEach((label, index) => {
      properties[`Charm ${index + 1}`] = label;
    });
    if (plan?.engraving) properties.Engraving = plan.engraving;
    properties._bundle_id = bundleId;
    properties._bundle_role = 'parent';

    const parent = {
      id: Number(formData.get('id')),
      quantity,
      properties,
    };
    const sellingPlan = formData.get('selling_plan');
    if (sellingPlan) parent.selling_plan = sellingPlan;

    const items = [
      parent,
      ...extras.map((item) => ({
        id: Number(item.id),
        quantity: Math.max(1, Number(item.quantity) || 1) * quantity,
        properties: {
          ...(item.properties || {}),
          _bundle_id: bundleId,
          _bundle_role: item.role,
        },
      })),
    ];

    const sections =
      typeof getCartSectionRequestIds === 'function' ? getCartSectionRequestIds() : [];
    let data = null;
    let fetchError = null;
    try {
      const response = await fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      data = await response.json();
    } catch (error) {
      fetchError = error;
    }

    if (data?.status || fetchError) {
      form.dispatchEvent(
        new CustomEvent('shapes:productform:error', {
          bubbles: true,
          detail: {
            sourceId: formId,
            variantId: parent.id,
            errors: data?.errors || data?.description || fetchError,
            message: data?.description || data?.message || null,
          },
        })
      );
      return;
    }

    if (data?.items?.[0]) {
      data.key = data.items[0].key;
      data.variant_id = data.items[0].variant_id;
    }

    form.dispatchEvent(new CustomEvent('shapes:productform:success', { bubbles: true }));
    document.body.dispatchEvent(
      new CustomEvent('shapes:cart:afteradditem', {
        bubbles: true,
        detail: { response: data, sourceId: formId },
      })
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
